import { useState } from "react";
import { PropsView } from "./Models";

export default function NotificationsView({ goBack }: PropsView) {
  const [activeTab, setActiveTab] = useState<"todas" | "favoritas">("todas");

  return (
    <div className="min-h-screen flex flex-col w-full bg-white rounded-t-3xl overflow-hidden">
      <header className="w-full text-black flex items-center py-4 px-4 shadow-sm">
        <div className="relative w-full flex items-center justify-between">
          <button onClick={goBack} className="flex items-center justify-center p-2">
            <img 
              src="/svg/icon-arrow-left.svg"
              width={24}
              height={24}
              alt="Voltar"
            />
          </button>
          <h1 className="text-xl font-normal text-black">Notificações</h1>
          <button className="flex items-center justify-center p-2">
            <img 
              src="/icon-ellipsis-v.png"
              width={20}
              height={20}
              alt="Menu"
            />
          </button>
        </div>
      </header>

      <main className="flex-1 w-full flex justify-center mt-[calc(32px)]">
        <article className="w-full max-w-[calc(480px)] px-4">
          {/* Tab Bar */}
          <div className="relative border-b border-gray-200">
            <div className="flex items-center gap-6">
              <button
                onClick={() => setActiveTab("todas")}
                className="flex flex-1 items-center justify-center relative pb-3"
              >
                <span
                  className={`text-base font-normal ${
                    activeTab === "todas"
                      ? "text-black"
                      : "text-gray-400"
                  }`}
                >
                  Todas
                </span>
                {activeTab === "todas" && (
                  <div className="absolute bottom-0 left-5 right-5 rounded-t-md h-1.5 bg-black -mb-px z-10" />
                )}
              </button>
              <button
                onClick={() => setActiveTab("favoritas")}
                className="flex flex-1 items-center justify-center relative pb-3"
              >
                <span
                  className={`text-base font-normal ${
                    activeTab === "favoritas"
                      ? "text-black"
                      : "text-gray-400"
                  }`}
                >
                  Favoritas
                </span>
                {activeTab === "favoritas" && (
                  <div className="absolute bottom-0 left-5 right-5 h-1.5 rounded-t-md bg-black -mb-px z-10" />
                )}
              </button>
            </div>
          </div>

          {/* Search Bar */}
          <div className="relative mt-8 mb-8">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <img 
                src="/icon-search.png"
                width={18}
                height={18}
                alt="Pesquisar"
              />
            </div>
            <input
              type="text"
              placeholder="Pesquisar"
              className="w-full bg-white rounded-md pl-10 pr-4 py-3 text-base text-black placeholder-gray-500 border focus:outline-none focus:border-gray-300 shadow-sm"
            />
          </div>

          {/* Empty State */}
          <div className="flex flex-col items-center justify-center mt-20">
            <div className="relative mb-8">
              {/* Large gray circle background */}
              <div className="w-44 h-44 bg-gray-100 rounded-full flex items-center justify-center">
                {/* Bell icon with slight rotation */}
                <div className="relative transform ">
                  <img 
                    src="/svg/notifier.svg"
                    width={89}
                    height={92}
                    alt="Notificações"
                    className="rotate-12"
                  />
                  <div className="absolute -top-1 left-5 bg-red-500 border-4 border-white  text-white text-xs font-bold rounded-full w-9 h-9 flex items-center justify-center">
                    0
                  </div>
                  
                </div>
                
              </div>
            </div>
            <h2 className="text-lg font-bold text-black mb-3 text-center">
              Sem notificações no momento!
            </h2>
            <p className="text-sm text-[#696966] text-center max-w-xs leading-relaxed">
              Sempre que tiver mensagem nova, ela aparece aqui.
            </p>
          </div>
        </article>
      </main>
    </div>
  );
}

